<template>
  <q-page padding>
    <div class="row col-12">
      <span class="text-brand-1 text-weight-bold text-h6">Gestão de Menus</span>
    </div>
    <div class="q-mt-xl">
      <div>
        <p></p>
        <q-btn
          :label="tab == 'menu' ? 'Criar Novo Menu' : 'Criar Novo Submenu'"
          no-caps
          class="btn"
          color="brand-1"
          icon="add"
          @click="modal = true"
        />
      </div>
    </div>
    <div class="q-mt-xl q-ml-md">
      <div
        style="font-size: 18px"
        class="q-mb-lg text-brand-1 text-weight-medium"
      >
        <span>Selecione as opções de menu e submenu para configurar</span>
      </div>
      <q-tabs
        dense
        class="text-grey"
        active-color="black"
        active-bg-color="brand-11"
        no-caps
        align="start"
        indicator-color="transparent"
        v-model="tab"
      >
        <q-tab
          class="col-3"
          style="border-radius: 5px"
          :class="{ greyBg: tab != 'menu' }"
          name="menu"
          label="Menu"
        >
        </q-tab>
        <q-tab
          :class="{ greyBg: tab != 'submenu' }"
          class="col-3 q-ml-md"
          name="submenu"
          style="border-radius: 5px"
          label="Submenu"
        >
        </q-tab>
      </q-tabs>
      <div class="row col-12 q-mt-xl">
        <TabelaMenu
          v-if="tab == 'menu'"
          @fecharModal="modal = false"
          :modal="modal"
        />

        <TabelaSubmenu v-else @fecharModal="modal = false" :modal="modal" />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch } from "vue";

import TabelaMenu from "../components/TabelaSubmenu.vue";
import TabelaSubmenu from "../components/TabelaPagina.vue";

export default {
  components: {
    TabelaMenu,
    TabelaSubmenu,
  },
  setup() {
    const tab = ref("menu");
    const modal = ref(false);

    watch(
      () => tab.value,
      () => {
        modal.value = false;
      }
    );

    return {
      tab,
      modal,
    };
  },
};
</script>

<style scoped>
.greyBg {
  background: #d9d9d9;
}
</style>
